import "./Locations.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
import LocationsEditDialog from "@/components/Locations/LocationsEditDialog/LocationsEditDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import LocationsFilter from "@/components/Locations/LocationsFilter/LocationsFilter.vue";
export default {
  name: "Locations",
  components: {
    LocationsFilter,
    LocationsEditDialog,
    OptionListDialog,
    LocationMap,
    TreeViewSelection
  },
  data: () => ({
    panels: [],
    config: null,
    editDialog: false,
    listMapDialog: false,
    listPostcodeDialog: false,
    dialogItem: {},
    search: "",
    deleted: false,
    loading: true,
    selectedState: "",
    selectedCountry: "",
    selectedDistrict: "",
    districts: [],
    countries: [],
    states: [],
    headers: [
      {
        text: "Ortsname",
        align: "start",
        value: "title"
      },
      { text: "PLZs", value: "postcodes" },
      { text: "Bezirk", value: "district" },
      { text: "Land", value: "state" },
      { text: "Nation", value: "country" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "10%"
      }
    ],
    editedIndex: -1,
    // field-names for mongodb already snake-case
    editedItem: {
      name: null,
      title: null,
      postcodes: [],
      alternatives: [],
      district: null,
      state: null,
      country: null,
      weight: 10,
      country_code: null,
      radius: [{ principal: "", radius: 0 }],
      geo: {
        type: "Point",
        coordinates: [10.2206211, 47.5592452]
      },
      is_base_entry: false,
      wikidata_id: null,
      belongs_to: "",
      osm_id: null,
      principals: []
    },
    defaultItem: {},
    locations: [],
    options: {},
    page: 1,
    total: 0,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    featureGroups: [],
    locationFilter: { limit: 10, skip: 0, page: 1 },
    itemsPerPage: 10
  }),
  async created() {
    this.defaultItem = Object.assign({}, this.editedItem);
    this.defaultItem.isNew = true;
    await this.loadConfig();
  },
  async mounted() {
    await this.loadAvailableFilterFacets();
    await this.getFeatureGroups();
    await this.loadLocations();
  },

  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    clientUrl() {
      return env.locations_api_client_url;
    }
  },

  watch: {
    search(val) {
      if (val.length >= 3) this.loadLocations();
      if (val === "") this.loadLocations();
    }
  },

  methods: {
    async previousPage() {
      const currentPage = this.page || 1;

      if (currentPage > 1) {
        this.page = currentPage - 1;
        await this.loadLocations();
      }
    },
    async nextPage() {
      const limit = this.itemsPerPage;

      const totalPages = Math.ceil(this.total / limit);
      const currentPage = this.page || 1;

      if (currentPage < totalPages) {
        this.page = currentPage + 1;
        await this.loadLocations();
      }
    },
    async loadConfig() {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(this.clientUrl + "config", {
          headers,
          params
        });
        this.config = response.data;
      } catch (error) {
        this.createError(error);
      }
    },
    async createConfig() {
      const postData = {
        id: this.currentPrincipal,
        _id: this.currentPrincipal
      };
      const headers = getTokenHeader();
      try {
        const res = await axios.post(`${this.clientUrl}config/`, postData, {
          headers
        });
        this.config = res.data;
      } catch (error) {
        this.createError(error);
      }
    },
    getFilter() {
      const { sortBy, sortDesc } = this.options;
      const itemsPerPage = this.itemsPerPage;
      const page = this.page || 1;
      const sortField = Array.isArray(sortBy) ? sortBy[0] : sortBy;

      const defaultFilter = {
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        page: page,
        isBackend: true,
        dir: sortDesc?.[0] ? "desc" : "asc"
      };

      if (this.isAdmin && this.deleted) {
        defaultFilter.deleted = true;
      }
      if (sortField) {
        defaultFilter.sort = sortField;
      }
      if (this.search) {
        defaultFilter.q = this.search;
      }

      return {
        ...defaultFilter,
        ...this.locationFilter,
        limit: itemsPerPage,
        page
      };
    },
    async onTableOptionsUpdated(nextOptions = {}) {
      const previousOptions = this.options || {};
      const previousSortBy = Array.isArray(previousOptions.sortBy)
        ? previousOptions.sortBy[0]
        : previousOptions.sortBy;
      const nextSortBy = Array.isArray(nextOptions.sortBy)
        ? nextOptions.sortBy[0]
        : nextOptions.sortBy;
      const previousSortDesc = Array.isArray(previousOptions.sortDesc)
        ? Boolean(previousOptions.sortDesc[0])
        : Boolean(previousOptions.sortDesc);
      const nextSortDesc = Array.isArray(nextOptions.sortDesc)
        ? Boolean(nextOptions.sortDesc[0])
        : Boolean(nextOptions.sortDesc);

      const requestedPage = Number(nextOptions.page);
      const nextPage =
        Number.isFinite(requestedPage) && requestedPage > 0 ? requestedPage : 1;
      const requestedItemsPerPage = Number(nextOptions.itemsPerPage);
      const nextItemsPerPage =
        Number.isFinite(requestedItemsPerPage) && requestedItemsPerPage > 0
          ? requestedItemsPerPage
          : this.itemsPerPage;

      const pageChanged = nextPage !== this.page;
      const itemsPerPageChanged = nextItemsPerPage !== this.itemsPerPage;
      const sortChanged =
        nextSortBy !== previousSortBy || nextSortDesc !== previousSortDesc;

      this.options = { ...nextOptions };
      this.itemsPerPage = nextItemsPerPage;
      this.page = itemsPerPageChanged ? 1 : nextPage;
      this.locationFilter = {
        ...this.locationFilter,
        limit: this.itemsPerPage,
        page: this.page
      };

      if (pageChanged || itemsPerPageChanged || sortChanged) {
        await this.loadLocations();
      }
    },
    async loadLocations() {
      this.loading = true;
      const headers = getTokenHeader();
      this.locationFilter = {
        ...this.locationFilter,
        limit: this.itemsPerPage,
        page: this.page || 1
      };

      if (headers) {
        const params = this.getFilter();

        try {
          const response = await axios.get(this.clientUrl + "location", {
            headers,
            params
          });
          this.locations = response?.data;
          let count = response?.headers?.["x-count"];
          if (isNaN(count)) {
            console.error("no number in x-count");
          }
          this.total = parseInt(count);
        } catch (err) {
          console.error("cant get locations", err);
        }
        this.loading = false;
      }
    },
    async getFeatureGroups() {
      try {
        const headers = getTokenHeader();
        const response = await axios.get(
          `${this.clientUrl}feature-groups?principal=${this.currentPrincipal}`,
          { headers }
        );
        this.featureGroups = response.data?.map(fg => ({
          ...fg,
          title: fg.name
        }));
      } catch (e) {
        console.error(e);
        this.$store.dispatch("createError");
      }
    },
    async loadAvailableFilterFacets() {
      const headers = getTokenHeader();

      if (headers) {
        try {
          const response = await axios.get(
            this.clientUrl + "location/availableFilterFacets",
            {
              params: {
                principal_id: this.currentPrincipal
              },
              headers
            }
          );

          this.districts =
            response?.data?.districts?.map(d => ({ title: d, _id: d })) || [];
          this.countries =
            response?.data?.countries?.map(c => ({ title: c, _id: c })) || [];
          this.states =
            response?.data?.states?.map(s => ({ title: s, _id: s })) || [];
        } catch (err) {
          console.error("cant get districts", err);
        }
      }
    },
    createItem() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.principals.push(this.currentPrincipal);
      this.editDialog = true;
    },
    editItem(item) {
      this.editedIndex = this.locations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteLocation(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.locations.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.locations.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    copyToPrincipal(item) {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = true;
      this.editedItem.orginId = item._id;
      this.editedItem.principals = this.currentPrincipal
        ? [this.currentPrincipal]
        : [];
      this.editedItem.is_base_entry = false;
      delete this.editedItem._id;
      this.editDialog = true;
    },
    async deleteLocation(item) {
      const title = item.title;
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${this.clientUrl}location/${item.id || item._id}`,
          { headers }
        );
      if (res.status === 200) {
        this.snackMessage(title + " gelöscht!", "#000");
      } else {
        this.snackMessage(
          item.title + " konnte nicht gelöscht werden!",
          this.mainRed
        );
      }
    },
    close() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    afterSave(close) {
      if (this.editedIndex > -1) {
        Object.assign(this.locations[this.editedIndex], this.editedItem);
      } else {
        this.locations.push(this.editedItem);
      }
      this.loadLocations();
      this.snackMessage("Erfolgreich gespeichert!");
      if (close) {
        this.close();
      }
    },
    createError(error) {
      this.snackMessage(
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
        "#c55c52"
      );
      console.error(error);
    },
    snackMessage(msg, color = "#00636C") {
      this.snackbarText = msg;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    async disconnectLocation(location) {
      try {
        const headers = getTokenHeader(),
          res = await axios.delete(
            `${this.clientUrl}location/${location._id}/${this.currentPrincipal}`,
            { headers }
          );
        if (res.status === 200) {
          location.principals = res.data.principals;
        }
      } catch (err) {
        this.createError(err);
      }
    },
    async connectLocation(location) {
      try {
        const headers = getTokenHeader(),
          res = await axios.put(
            `${this.clientUrl}location/${location._id}/${this.currentPrincipal}`,
            null,
            { headers }
          );

        if (res.status === 200) {
          location.principals = res.data.principals;
        }
      } catch (err) {
        this.createError(err);
      }
    },
    showMap(item) {
      this.listMapDialog = true;
      this.dialogItem = item;
    },
    showPostcodes(item) {
      this.listPostcodeDialog = true;
      this.dialogItem = item;
    },
    async resetFilter() {
      this.deleted = false;
      this.selectedCountry = "";
      this.selectedState = "";
      this.selectedDistrict = "";
      this.page = 1;

      await this.loadLocations();
    },
    async setState(state) {
      if (state?.[0]?.length) {
        this.selectedState = state[0];
      } else {
        this.selectedState = "";
      }
      await this.updateFilter();
    },

    async updateFilter() {
      this.page = 1;
      this.locationFilter = {
        limit: this.itemsPerPage,
        page: this.page
      };

      if (this.selectedCountry) {
        this.locationFilter.country = this.selectedCountry;
      }
      if (this.selectedState) {
        this.locationFilter.state = this.selectedState;
      }
      if (this.selectedDistrict) {
        this.locationFilter.district = this.selectedDistrict;
      }
      await this.loadLocations();
    }
  }
};
